// extracted by mini-css-extract-plugin
export default {"bodyDivider":"BodyDivider_bodyDivider__Z4nlW"};